var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTutiralWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_139_716)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1867 17.0918H18.593V20.6918H17.1867V17.0918Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8882 16.1582C18.256 16.1582 18.6084 15.8348 18.5914 15.4551C18.5743 15.0741 18.2824 14.752 17.8882 14.752C17.5204 14.752 17.1681 15.0753 17.1851 15.4551C17.2022 15.836 17.4941 16.1582 17.8882 16.1582Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1295 11.9606V0H3.09023C1.38628 0 0 1.3455 0 3.04945V21.0007H0.0148594C0.171047 22.6805 1.58789 24 3.30773 24H17.8973C21.2624 24 24 21.3031 24 17.9382C24 14.9952 21.9059 12.5321 19.1295 11.9606ZM17.7211 11.8383C14.6227 11.9266 12.0957 14.3357 11.8201 17.3845H5.65528V1.36767H17.7211V11.8383ZM3.09023 1.36767H4.24678V17.3845H3.30773C2.60128 17.3845 1.94639 17.6078 1.40845 17.9866V3.04945C1.40845 2.12208 2.16291 1.36767 3.09023 1.36767ZM3.30773 22.5915C2.26045 22.5915 1.40845 21.7395 1.40845 20.6923C1.40845 19.645 2.26045 18.793 3.30773 18.793H11.8549C11.9135 19.209 12.014 19.6118 12.1524 19.9967H3.56916V21.4052H12.8782C13.1838 21.8462 13.5459 22.2452 13.954 22.5916H3.30773V22.5915ZM17.8974 22.6323C15.309 22.6323 13.2032 20.5265 13.2032 17.9382C13.2032 15.3498 15.309 13.244 17.8974 13.244C20.4858 13.244 22.5915 15.3498 22.5915 17.9382C22.5915 20.5265 20.4857 22.6323 17.8974 22.6323Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.41229 4.10547H14.1261V5.51392H9.41229V4.10547Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.82007 7.16406H15.7184V8.57252H7.82007V7.16406Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_139_716"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTutiralWhiteIcon);
export default __webpack_public_path__ + "static/media/tutiral-white-icon.1bfff2dd7db04f9779269ae1c7f7b001.svg";
export { ForwardRef as ReactComponent };